/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDCornerRightUpIcon64Regular = forwardRef('ArrowDCornerRightUpIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M58.328 25.44a1.5 1.5 0 0 1-2.122 2.12L41.268 12.623A2.53 2.53 0 0 0 41 12.39V43.5a9.5 9.5 0 0 1-9.5 9.5h-24a1.5 1.5 0 0 1 0-3h24a6.5 6.5 0 0 0 6.5-6.5V12.39c-.093.07-.183.147-.268.232L22.794 27.561a1.5 1.5 0 1 1-2.122-2.122l14.939-14.938a5.5 5.5 0 0 1 7.778 0l14.939 14.938Z" })));
});
